/*
  Tanuki — allinea il badge "Preorder" dell'app Stoq/Restock Rocket ai badge del tema.

  L'app inietta via JS uno <span class="restock-rocket-preorder-badge preorder-badge-collection">
  posizionato in absolute (top/right), quindi fuori dalla fila dei badge del tema
  ("Consegna in 1 Giorno", "-50%"). Qui lo spostiamo dentro lo stesso contenitore,
  come PRIMO elemento della fila.

  Non tocchiamo testo e colori del badge: restano configurabili dall'app.
*/
(function () {
  'use strict';

  var BADGE = '.restock-rocket-preorder-badge';
  // Contenitori badge del tema, in ordine di preferenza
  var TARGETS = '.predictive-search__badges, .card__badge--stack, .card__badge, .pdp-badges';
  // Elemento "card" entro cui cercare il contenitore
  var CARDS =
    '.predictive-search__item, .predictive-search__list-item, .card-wrapper, ' +
    '.collection-product-card, .card, .product-card, .product__info-wrapper';

  function alignOne(badge) {
    if (badge.dataset.tnkAligned === '1') return;

    var card = badge.closest(CARDS);
    if (!card) return;

    var target = card.querySelector(TARGETS);
    // Nessuna fila di badge in questa card: lasciamo il badge dov'è (comportamento originale)
    if (!target) return;

    // già al posto giusto
    if (target.firstElementChild === badge) {
      badge.dataset.tnkAligned = '1';
      badge.classList.add('preorder-badge--inline');
      return;
    }

    badge.dataset.tnkAligned = '1';
    badge.classList.add('preorder-badge--inline');
    target.insertBefore(badge, target.firstChild);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = scope.querySelectorAll(BADGE + ':not([data-tnk-aligned="1"])');
    for (var i = 0; i < found.length; i++) alignOne(found[i]);
  }

  var pending = null;
  function scheduleScan() {
    if (pending) return;
    pending = requestAnimationFrame(function () {
      pending = null;
      scan(document);
    });
  }

  function start() {
    scan(document);

    // L'app inietta i badge in modo asincrono (e il dropdown di ricerca si
    // ri-renderizza a ogni battuta): osserviamo le aggiunte al DOM.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          scheduleScan();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Rete di sicurezza: l'app può caricarsi tardi
    setTimeout(scheduleScan, 1200);
    setTimeout(scheduleScan, 3000);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
